class FooterNavigation extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.toggle.bind(this);
    this.updateState = this.updateState.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.toggleBtn = this.querySelector('.js-toggle');
    this.content = this.querySelector('.js-content');

    if (!this.toggleBtn || !this.content) return;

    this.toggleBtn.addEventListener('click', this.toggle);
    window.addEventListener('resize', this.handleResize);

    this.updateState();
  }

  disconnectedCallback() {
    this.toggleBtn.removeEventListener('click', this.toggle);
    window.removeEventListener('resize', this.handleResize);
  }

  toggle() {
    if (window.innerWidth >= 750) return;

    const isOpen = this.classList.contains('open');

    if (isOpen) {
      this.closeContent();
    } else {
      this.openContent();
    }
  }

  openContent() {
    this.classList.add('is-animating');
    this.content.style.maxHeight = this.content.scrollHeight + 'px';
    this.classList.add('open');

    setTimeout(() => {
      this.classList.remove('is-animating');
    }, 300);
  }

  closeContent() {
    this.classList.add('is-animating');
    this.content.style.maxHeight = this.content.scrollHeight + 'px';
    void this.content.offsetHeight;

    this.content.style.maxHeight = '0px';
    this.classList.remove('open');

    setTimeout(() => {
      this.classList.remove('is-animating');
    }, 300);
  }

  updateState() {
    const isDesktop = window.innerWidth >= 750;

    if (isDesktop) {
      this.content.style.maxHeight = 'none';
      this.classList.add('open');
    } else {
      if (!this.classList.contains('open')) {
        this.content.style.maxHeight = '0px';
      }
    }
  }

  handleResize() {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(this.updateState, 200);
  }
}

if (!customElements.get('footer-navigation')) {
  customElements.define('footer-navigation', FooterNavigation);
}